import React, {FC} from "react";
import {UIText} from "../../../../enums/UIText/UIText";
import {useAppSelector} from "../../../../hooks/redux";
import {getLanguage} from "../../../../store/selectors/appSelector";
import style from "./CopyrightFooter.module.css";
import {getTextByLanguage} from "../../../../enums/utils/getTextByLanguage";

export const CopyrightFooter: FC = () => {

    const language = useAppSelector(getLanguage);

  return <div className={style.copyrightFooter}>
      {new Date().getFullYear()} {getTextByLanguage(UIText.copyrightFooter.copyright, language)}
  </div>
};
